import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import dayjs from 'dayjs';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import Avatar from '@components/avatar';
import VoteList from '@components/voteList';
import { formatTime } from '@utils/timeUtils';
import AvatarList from '@components/avatarList';
import { BASE_IMG_URL, setPostImage } from '@images/imageUrls';
import CommonPopup from '@components/commonPopup';
import CommonAlert from '@components/commonAlert';
import ManagePermissions from '@components/managePermissions';
import classNames from 'classnames';
import { Radio, Input, DatePickerProps, DatePicker, Checkbox } from 'antd';
import parse, { domToReact } from 'html-react-parser';
import Toast from '@components/Toast';
import { getFormOptionText } from '../common/formOptions';
import { getFeedbackProductName } from '../common/feedbackProduct';
import PostList from '@components/postList';
import { Image, Spin } from 'antd';
import { Carousel } from 'antd';
import CommentInput from '@components/commentInput/h5';
import updateImageListSrc from '@utils/update-image-list-src'
import { px2rem } from '@utils/px2rem'
import './index.scss'
import ThreadDetailImgList from '@components/threadDetailImgList';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { formatNumberToWan } from '@utils/formatNumber';
import CountDown from "@components/countDown";
import CommonPopupNew from "@components/commonPopupNew";
import {
    getProtectedEventHandlers,
    isContentProtectionEnabled,
    protectedMediaStyle,
} from '@utils/contentProtection';
import { replaceEmojiCodes } from '@utils/emoji';
import { getUrlWhitelist, cleanHttpLinks } from '@utils/whiteList';
import { moveThread } from '@server';
import { getThreadConversionAccess, getThreadConversionBlockedReason, getThreadConversionParams } from '@utils/threadConversion';
import type { ThreadConversionPayload } from '@components/threadConversion';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const { TextArea } = Input;

interface ThreadDetailH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    threadId?: any
    // createThreadOpera?: any
    createFollowUser?: any
    followDelete?: any
    createActivityVote?: any
    isVivoBrowserStatus: any
    likeClick?: (data: any, type: 'thread' | 'post') => Promise<any> | void
    favoriteClick?: (status: boolean) => Promise<any> | void
    shareClick?: () => void
    postsUpdate?: (id: any, actionType: 'delete' | 'sink' | 'sticky', type: 'post' | 'comment', currentState?: boolean) => Promise<any>
    submitFeedbackSame?: () => void
    handleState?: (data: any) => void
    sendConfirmClick?: (solveStatus: number) => void
    sendConfirmPopupStatus?: boolean // 客服反馈是否已解决问题确认弹框
    serviceStatus: boolean    // 客服反馈入口是否显示
    satisfactionLevel?: any  // 解决问题的满意程度
    currentSatisfactionIndex?: any  // 当前解决问题的满意程度
    judgeTextValue?: any    // 本次反馈服务的评价或建议
}
interface ThreadDetailH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    topicList?: any
    rewardPopupStatus: boolean
    rewardCheckValue: any
    reportPopupStatus: any
    reportReasonList: any
    reportReason: any
    reportDescription: any
    menuDropStatus: any
    selectedCommentId?: any
    selectedCommentIsSink?: boolean
    selectedCommentIsSticky?: boolean
    deletePopupStatus?: boolean
    swiperActiveIndex?: any
    commentInputVisible?: boolean
    reportType?: any
    formInfo: any[]  // 表单字段数组
    formCreateAt: string  // 表单创建时间
    consentStatus: boolean  // 用户是否同意
    submitStatus: boolean  // 是否可提交
    popupStatus: boolean  // 表单弹窗显示状态
    auditStatus: boolean  // 审核状态
    formSubmittedData: any[]  // 已提交的表单数据缓存
    formCountdown: any  // 表单倒计时
    formStatus: 'notStarted' | 'ongoing' | 'ended'  // 表单状态
    formSubmitConfirmVisible: boolean  // 表单提交确认弹窗显示状态
    windowWidth: any
    scrollY: any
    formFixedIsShow: any // 悬浮表单入口是否显示
    formFixedIsShowClose: any
    showLotteryFixedEnter: boolean // 是否显示抽奖悬浮入口
    hideLotteryFixedEnter: boolean
    whiteList: string[]
    whiteHttpList: string[]
}
@inject('app', 'site', 'user', 'thread')
@observer
class ThreadDetailH5Page extends BasePage<ThreadDetailH5PageProps, ThreadDetailH5State> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        topicList: [],
        rewardPopupStatus: false,    // 打赏弹框
        rewardCheckValue: 0,    // 打赏V币数
        reportPopupStatus: false,    // 举报弹框
        reportReasonList: [
            { value: '淫秽色情', label: '淫秽色情' },
            { value: '垃圾广告', label: '垃圾广告' },
            { value: '暴力恐怖', label: '暴力恐怖' },
            { value: '违规传播', label: '违规传播' },
            { value: '政治谣言', label: '政治谣言' },
            { value: '谩骂侮辱', label: '谩骂侮辱' },
            { value: '灌水发帖/评论', label: '灌水发帖/评论' },
            { value: '其他', label: '其他' },
        ],
        reportReason: '',   // 举报理由
        reportDescription: '',  // 举报描述
        menuDropStatus: false,  // 标题右侧管理下拉框状态，默认折叠
        selectedCommentId: undefined,  // 当前选中要操作的评论 id
        selectedCommentIsSink: false,
        selectedCommentIsSticky: false,
        deletePopupStatus: false,  // 删除弹框状态
        swiperActiveIndex: 0,   // 动态帖图片轮播索引
        commentInputVisible: false,  // 评论输入框显示状态
        reportType: 1,  // 举报类型0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
        formInfo: [],  // 表单字段数组
        formCreateAt: '',  // 表单创建时间
        consentStatus: false,  // 用户是否同意
        submitStatus: false,  // 是否可提交
        popupStatus: false,  // 表单弹窗显示状态
        auditStatus: false,  // 审核状态
        formSubmittedData: [],  // 已提交的表单数据缓存
        formCountdown: '',  // 表单倒计时
        formStatus: 'notStarted' as 'notStarted' | 'ongoing' | 'ended',  // 表单状态
        formSubmitConfirmVisible: false,  // 表单提交确认弹窗显示状态
        windowWidth: 0, // 浏览器宽度
        scrollY: 0, // 滚动高度
        formFixedIsShow: false, // 悬浮表单入口是否显示
        formFixedIsShowClose: false,    // 悬浮表单入口是否手动关闭
        showLotteryFixedEnter: false, // 是否显示抽奖悬浮入口
        hideLotteryFixedEnter: true,    // 是否隐藏抽奖悬浮入口，默认不隐藏，点击关闭就隐藏
        whiteList: [],
        whiteHttpList: [],
    };
    private countdownInterval: any = null;  // 倒计时定时器
    private resizeTimeout: NodeJS.Timeout | null = null;
    private scrollTimeout: NodeJS.Timeout | null = null;
    private wxShareId: any = null;  // 已初始化微信分享的帖子 id
    private docContextMenuHandler: ((e: MouseEvent) => void) | null = null;  // 版权保护右键禁用
    private lotteryFixedEnterInitialized = false;  // 抽奖悬浮入口是否已初始化
    componentDidMount() {
        this.calculateFormStatus();
        // 每秒更新倒计时
        this.countdownInterval = setInterval(() => {
            this.calculateFormStatus();
        }, 1000);

        this.updateWindowDimensions();
        this.updateScrollPosition();
        this.initWhiteList();
        // 添加事件监听
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
        // 加载微信 JSSDK 相关脚本
        this.loadWxShareScripts();
        // 初始化抽奖悬浮入口显示状态
        this.initLotteryFixedEnter();
        super.componentDidMount();
    }

    componentDidUpdate(prevProps: any) {
        const currThreadData = (this.props as any).thread?.threadData;
        // MobX store 是同一引用，不能用 prevProps 比较，用实例变量跟踪
        if (currThreadData?.id && currThreadData.id !== this.wxShareId) {
            this.wxShareId = currThreadData.id;
            this.initWxShare(currThreadData);
        }
        // 版权保护：数据加载后补充 document 级别右键禁用
        if (isContentProtectionEnabled(currThreadData?.allowDownload) && !this.docContextMenuHandler) {
            this.docContextMenuHandler = (e: MouseEvent) => e.preventDefault();
            document.addEventListener('contextmenu', this.docContextMenuHandler);
        }
        // 帖子数据加载完成后，初始化抽奖悬浮入口显示状态
        const lottery = currThreadData?.lotteryActivities?.length > 0 ? currThreadData?.lotteryActivities?.[0] : null;
        if (lottery && !this.lotteryFixedEnterInitialized) {
            const lotteryEnter = document.getElementById('lotteryEnter');
            if (lotteryEnter) {
                this.lotteryFixedEnterInitialized = true;
                // 延迟执行，确保布局稳定后再计算位置
                setTimeout(() => {
                    this.initLotteryFixedEnter();
                }, 100);
            }
        }
    }

    // 动态加载微信分享脚本
    loadWxShareScripts = () => {
        const loadScript = (src: string): Promise<void> => {
            return new Promise((resolve) => {
                if (document.querySelector(`script[src="${src}"]`)) {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => resolve();
                script.onerror = () => resolve(); // 静默失败
                document.head.appendChild(script);
            });
        };
        loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js').then(() => {
            const encodedUrl = encodeURIComponent(window.location.href.split('#')[0]);
            console.log('[WxShare] loading vivo wx script with url:', window.location.href.split('#')[0]);
            loadScript(`//wx.vivo.com.cn/api/js/weixin.js?list=onMenuShareQQ,onMenuShareWeibo,onMenuShareQZone,updateAppMessageShareData,updateTimelineShareData,onMenuShareAppMessage,onMenuShareTimeline&url=${encodedUrl}`).then(() => {
                // 确认 wx.config 用的实际 url（如果 vivo 脚本暴露了 _wxConfigParams 之类的）
                const wxObj = (window as any).wx;
                if (wxObj) {
                    console.log('[WxShare] wx.config url check - wx object keys:', Object.keys(wxObj).slice(0, 10));
                }
                // 暂时禁用 refreshShareData，测试是否与 wx.ready 注册有冲突
                // if ((window as any).shareData && typeof (window as any).refreshShareData === 'function') {
                //     (window as any).refreshShareData();
                // }
                // 触发提前设置好的 wx share（initWxShare 先于脚本加载时设置的）
                if (typeof (window as any)._pendingWxShare === 'function') {
                    (window as any)._pendingWxShare();
                    (window as any)._pendingWxShare = null;
                }
            });
        });
    }

    // 初始化白名单
    initWhiteList = async () => {
        const { whiteList, whiteHttpList } = await getUrlWhitelist();
        this.setState({ whiteList, whiteHttpList });
    }

    // 初始化微信分享数据
    initWxShare = (threadData: any) => {
        const base = window.location.origin;
        const id = threadData?.id;
        const title = threadData?.title || 'vivo社区';
        const desc = threadData?.summary || title;
        const firstImage = (threadData?.images && threadData.images.length > 0) ? threadData.images[0]?.url || threadData.images[0] : `${base}/favicon.ico`;
        const shareUrl = `${base}/threadDetail/${id}`;

        const shareConfig = {
            title,
            desc,
            link: shareUrl,
            imgUrl: firstImage,
            success: function() {},
            cancel: function() {},
        };

        (window as any).shareData = {
            picUrl: firstImage,
            url: shareUrl,
            title: title,
            desc: desc,
            timelineTitle: title,
            callback: function(type: string) {}
        };

        const applyShare = () => {
            const wx = (window as any).wx;
            if (!wx) {
                console.warn('[WxShare] wx not found');
                return;
            }
            console.log('[WxShare] calling wx.ready, shareConfig:', shareConfig);
            wx.ready(() => {
                console.log('[WxShare] wx.ready fired');
                // 新版 API（微信 6.7.2+）
                if (typeof wx.updateAppMessageShareData === 'function') {
                    wx.updateAppMessageShareData({ ...shareConfig, success: () => console.log('[WxShare] updateAppMessageShareData success'), fail: (e: any) => console.error('[WxShare] updateAppMessageShareData fail', e) });
                }
                if (typeof wx.updateTimelineShareData === 'function') {
                    wx.updateTimelineShareData({ title, link: shareUrl, imgUrl: firstImage, success: () => console.log('[WxShare] updateTimelineShareData success'), fail: (e: any) => console.error('[WxShare] updateTimelineShareData fail', e) });
                }
                // 兜底老版 API
                if (typeof wx.onMenuShareAppMessage === 'function') {
                    wx.onMenuShareAppMessage(shareConfig);
                }
                if (typeof wx.onMenuShareTimeline === 'function') {
                    wx.onMenuShareTimeline({ title, link: shareUrl, imgUrl: firstImage, success: function() {}, cancel: function() {} });
                }
            });
        };

        // 如果 wx 已加载，直接执行；否则等脚本加载完再执行
        if ((window as any).wx) {
            applyShare();
        } else {
            (window as any)._pendingWxShare = applyShare;
        }

        // 暂时禁用 refreshShareData，测试是否与我们的注册有冲突
        // if (typeof (window as any).refreshShareData === 'function') {
        //     (window as any).refreshShareData();
        // }
    }

    componentWillUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
        // 移除 document 级别的右键禁用
        if (this.docContextMenuHandler) {
            document.removeEventListener('contextmenu', this.docContextMenuHandler);
            this.docContextMenuHandler = null;
        }

        // 清除定时器
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    }

     // 更新窗口尺寸
     updateWindowDimensions = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }

    // 更新滚动位置
    updateScrollPosition = () => {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.setState({ scrollY });

        // 检查滚动高度
        let formBoxTop = 200;
        if (scrollY >= formBoxTop - 480 && scrollY < formBoxTop + 480) {
            this.setState({
                formFixedIsShow: false
            })
        } else if (scrollY > formBoxTop + 480 || scrollY < formBoxTop - 480) {
            // console.log('显示');
            this.setState({
                formFixedIsShow: true
            })
        }
    }

    // 防抖处理窗口大小变化
    handleResize = () => {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            this.updateWindowDimensions();
            console.log(`🔄 浏览器宽度变化: ${window.innerWidth}px`);
        }, 100);
    }

    // 防抖处理滚动事件
    handleScroll = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }


        this.scrollTimeout = setTimeout(() => {
            this.updateScrollPosition();
            this.updateLotteryFixedEnter();
        }, 16); // 约60fps
    }

    /**
     * 初始化抽奖悬浮入口显示状态
     * 获取 lotteryEnter 元素位置，判断是否在可视区域内
     */
    initLotteryFixedEnter = () => {
        const lotteryEnter = document.getElementById('lotteryEnter');
        if (!lotteryEnter) {
            // console.log('initLotteryFixedEnter: lotteryEnter 元素不存在');
            return;
        }

        const rect = lotteryEnter.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // console.log('initLotteryFixedEnter:', {
        //     top: rect.top,
        //     bottom: rect.bottom,
        //     windowHeight,
        //     isInViewport: rect.top >= 0 && rect.bottom <= windowHeight
        // });

        // 初始化时，如果 lotteryEnter 不在可视范围内，显示悬浮入口
        const isInViewport = rect.top >= 0 && rect.bottom <= windowHeight;
        this.setState({ showLotteryFixedEnter: !isInViewport });
    }

    /**
     * 更新抽奖悬浮入口显示状态
     * 根据滚动位置判断是否显示悬浮入口
     */
    updateLotteryFixedEnter = () => {
        const { showLotteryFixedEnter } = this.state;
        const lotteryEnter = document.getElementById('lotteryEnter');
        if (!lotteryEnter) return;

        const rect = lotteryEnter.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // 判断 lotteryEnter 是否在可视区域内
        const isInViewport = rect.top >= 0 && rect.bottom <= windowHeight;

        const shouldShow = !isInViewport;

        if (showLotteryFixedEnter !== shouldShow) {
            this.setState({ showLotteryFixedEnter: shouldShow });
        }
    }

    // 计算表单状态和倒计时
    calculateFormStatus = () => {
        const { thread } = this.props;
        const threadData: any = thread?.threadData;

        if (!threadData?.hasForm || !threadData?.form) {
            return;
        }

        const form = threadData.form;
        const now = new Date().getTime();
        const startTime = form.startAt ? new Date(form.startAt).getTime() : now;
        const endTime = form.endAt ? new Date(form.endAt).getTime() : now;

        let status: 'notStarted' | 'ongoing' | 'ended' = 'notStarted';
        let countdown: any = '';

        if (now < startTime) {
            // 未开始
            status = 'notStarted';
            countdown = this.formatStartTime(form.startAt);
        } else if (now >= startTime && now < endTime) {
            // 进行中
            status = 'ongoing';
            countdown = this.formatCountdown(endTime - now);
        } else {
            // 已结束
            status = 'ended';
            countdown = this.formatStartTime(form.startAt);  // 已结束时显示开始时间
        }

        this.setState({
            formStatus: status,
            formCountdown: countdown
        });
    }

    // 格式化开始时间（显示为 月日时分 格式）
    formatStartTime = (startTime: string) => {
        if (!startTime) return '';
        try {
            const date = new Date(startTime);
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${month}月${day}日${hours}时${minutes}分`;
        } catch (e) {
            return '';
        }
    }

    // 格式化倒计时（显示为 X天X时X分 格式）
    formatCountdown = (ms: number) => {
        if (ms <= 0) return { text: '已结束', isEnded: true };

        const days = Math.floor(ms / (1000 * 60 * 60 * 24));
        const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));

        if (days > 0) {
            return { days, hours, minutes, isEnded: false };
        } else if (hours > 0) {
            return { hours, minutes, isEnded: false };
        } else {
            return { minutes, isEnded: false };
        }
    }
    // 跳转到帖子详情页
    handleThreadClick = (item: any) => {
        // if(item.type == 3) {    // 是活动
        //     this.props.history && this.props.history.push(`/activityDetail/${item.id}`);
        // } else {    // 是其他
        //     // this.props.history && this.props.history.push(`/threadDetail/${item.id}`);
        // }
        window.open(`/threadDetail/${item.id}`);
    };

    // // 确认投票
    // handleVoteSubmit = (selectedOptions: string[]) => {
    //     console.log('用户选择了:', selectedOptions);
    //     // 这里可以发送到后端API
    // };
    // // 投票选择
    // handleVoteChange = (selected: string[]) => {
    //     console.log('选择变化:', selected);
    // };

    // 打开打赏弹框
    openRewardPopup = () => {
        this.setState({
            rewardPopupStatus: true
        })
    }
    // 关闭所有弹框
    closePopup = () => {
        // Toast.info('关闭')
        this.setState({
            rewardPopupStatus: false,   // 打赏弹框
            reportPopupStatus: false,   // 举报弹框
            menuDropStatus: false,  //右上角下拉框
        })
    }
    // 确定打赏
    rewardConfirm = () => {
        let { rewardCheckValue } = this.state;
        if (rewardCheckValue == 0) {
            Toast.info('请选择打赏V币数');
            return false;
        }
        const { thread, threadId } = this.props;
        if (thread) {
            let params: any = {
                id: threadId,
                type: 0, // 0是主题
                scoreReward: rewardCheckValue,
                source: 'PC'
            }
            thread.postsCreate(params).then(res => {
                const successCode = typeof res.code !== 'undefined' ? res.code : res.Code;
                if (successCode === 0) {
                    const data = res.data || res.Data;
                    if (data) {
                        thread.prependPostToList?.(data);
                        thread.getThreadDetail(threadId, {});
                    }
                    Toast.success({ content: '打赏成功' });
                } else {
                    Toast.info(res.msg || res.Message || '打赏失败');
                }
                this.setState({
                    rewardPopupStatus: false,   // 打赏弹框
                })
            })
        }
    }

    // ===================== 表单相关方法 =====================
    // 获取表单信息
    onGetFormInfoList = async (isReadOnly: boolean = false) => {
        const { thread } = this.props;
        const threadData = thread?.threadData;

        if (!threadData?.hasForm) {
            return;
        }

        try {
            // 如果有已提交的缓存数据，优先使用缓存（不刷新页面再次打开时回显已填写内容）
            if (this.state.formSubmittedData && this.state.formSubmittedData.length > 0) {
                this.setState({
                    formInfo: this.state.formSubmittedData,
                    auditStatus: true,
                    consentStatus: true
                });
                return;
            }

            if (threadData?.form?.fields) {
                // 深拷贝字段数据，避免修改原始数据导致下次无法回显
                const fields = JSON.parse(JSON.stringify(threadData.form.fields));
                // 检查是否有任何已填写的数据
                let hasAnySubmittedValue = false;

                // 处理表单字段
                fields.forEach((field: any) => {
                    // 检查是否有之前填写的数据（注意：value为0也是有效值）
                    const hasSubmittedValue = field.value !== undefined && field.value !== null && field.value !== '';
                    if (hasSubmittedValue) {
                        hasAnySubmittedValue = true;
                    }

                    if (hasSubmittedValue) {
                        // 使用之前的值
                        if (field.type === 'checkbox') {
                            // 多选：value是逗号分隔的索引
                            const selectedIndices = String(field.value).split(',').filter(v => v).map(v => parseInt(v));
                            field.list = (field.options || []).map((option: any, index: number) => ({
                                label: getFormOptionText(option),
                                checked: selectedIndices.includes(index),
                                index: index
                            }));
                            // 保存为数组格式，与新填写时的onCheckBox逻辑保持一致
                            field.values = selectedIndices.map(i => i.toString());
                        } else if (field.type === 'radio') {
                            // 单选：value是索引
                            field.options = (field.options || []).map(getFormOptionText);
                            // 保持为数字格式，与 onRadioChange 逻辑一致
                            field.values = parseInt(field.value);
                        } else if (field.type === 'image') {
                            // 图片：value 可能是id(数字)或完整对象
                            // 如果是对象则直接用，如果是数字则只能保存id（服务器需要返回完整数据）
                            field.values = typeof field.value === 'object' ? field.value : field.value;
                        } else {
                            // 文本输入
                            field.values = field.value;
                        }
                    } else {
                        // 新填写的表单
                        field.values = null;

                        if (field.type === 'checkbox') {
                            // 多选框：生成 list 结构
                            field.list = (field.options || []).map((option: any, index: number) => ({
                                label: getFormOptionText(option),
                                checked: false,
                                index: index
                            }));
                        }

                        if (field.type === 'radio') {
                            // 单选框：统一提取选项文本，空内容不回退为对象。
                            field.options = (field.options || []).map(getFormOptionText);
                        }
                    }
                });

                // 如果有任何已填写的数据，自动进入只读模式
                const finalReadOnly = isReadOnly || hasAnySubmittedValue;

                if (!finalReadOnly) {
                    this.onCheckedFormStatus();
                }

                // 只读模式下保持原有的同意状态，新表单则重置
                this.setState({
                    formInfo: fields,
                    consentStatus: finalReadOnly ? this.state.consentStatus : false,
                    formCreateAt: new Date().toISOString(),
                    auditStatus: finalReadOnly
                });
            }
        } catch (error) {
            console.error('获取表单信息失败:', error);
        }
    }

    // 检查表单填写状态
    onCheckedFormStatus = () => {
        let { formInfo, consentStatus } = this.state;
        let status = true;

        formInfo.forEach((field: any) => {
            if ((field.values === null || field.values?.length === 0) && field.isRequired) {
                status = false;
            }
        });

        if (!consentStatus) {
            status = false;
        }

        this.setState({
            submitStatus: status
        });
    }

    // 多选框变化
    onCheckBox = (index: number, key: number) => {
        let { formInfo } = this.state;
        const selectList: any[] = [];

        formInfo[index].list[key].checked = !formInfo[index].list[key].checked;

        formInfo[index].list.forEach((v: any) => {
            if (v.checked) {
                selectList.push(v.index.toString());
            }
        });

        formInfo[index].values = selectList;

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 单选框变化
    onRadioChange = (k: number, key: any) => {
        let { formInfo } = this.state;
        formInfo[k].values = parseInt(key);

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文本输入变化
    onWzNum = (key: number, value: string) => {
        let { formInfo } = this.state;
        formInfo[key].values = value;

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 打开文件选择对话框
    handleImageUploadClick = (fieldIndex: number) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;
            if (!file.type.startsWith('image/')) {
                Toast.info({ content: '请选择图片文件' });
                return;
            }
            const maxSize = 50 * 1024 * 1024;
            if (file.size > maxSize) {
                Toast.info({ content: '图片大小不能超过50MB' });
                return;
            }
            await this.uploadFormImage(file, fieldIndex);
        };
        input.click();
    }

    // 上传表单图片
    uploadFormImage = async (file: File, fieldIndex: number) => {
        try {
            const formData = new FormData();
            formData.append('type', '1');
            formData.append('file', file);
            const { uploadAttachment } = require('@server');
            const response = await uploadAttachment(formData);
            if (response.code === 0 && response.data?.id) {
                let { formInfo } = this.state;
                formInfo[fieldIndex].values = response.data;
                this.setState({ formInfo }, () => this.onCheckedFormStatus());
                Toast.success({ content: '图片上传成功' });
            } else {
                Toast.info({ content: response.message || '图片上传失败' });
            }
        } catch (error: any) {
            console.error('图片上传失败:', error);
            Toast.info({ content: '图片上传失败，请重试' });
        }
    }

    // 文件上传前处理
    uploadChange = (files: any[], item: any, key: number) => {
        if (files.length > 0) {
            return;
        }

        let { formInfo } = this.state;
        formInfo[key].values = files.length === 0 ? '' : files[0];

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文件上传完成处理
    uploadComplete = (files: any[], i: number, key: number) => {
        let { formInfo } = this.state;
        // files是数组，取第一个元素的url
        if (files && files.length > 0 && files[0]?.url) {
            formInfo[key].values = files[0].url;
        }

        this.setState({ formInfo }, () => {
            this.onCheckedFormStatus();
        });
    }

    // 文件上传移除
    uploadRemove = (files: any[], item: any) => {
        // 移除逻辑
    }

    // 提交表单
    onSendServer = (e: any) => {
        let { formInfo, submitStatus, formCreateAt } = this.state;
        const { thread } = this.props;
        const threadData: any = thread?.threadData;

        if (!submitStatus) {
            Toast.info({ content: '请填写完整信息!' });
            return false;
        }

        // 显示确认弹窗
        this.setState({ formSubmitConfirmVisible: true });
    }

    // 确认提交表单
    confirmSubmitForm = () => {
        let { formInfo, formCreateAt } = this.state;
        const { thread } = this.props;
        const threadData: any = thread?.threadData;
        this.setState({ formSubmitConfirmVisible: false });
        this.submitForm(formInfo, threadData, formCreateAt);
    }

    // 真正提交表单
    submitForm = (formInfo: any[], threadData: any, formCreateAt: string) => {
        const { thread } = this.props;

        const signUpInfo: any[] = [];
        formInfo?.forEach((field: any) => {
            if (field.type === 'checkbox') {
                // checkbox：没有选择则传空数组
                const value = field.values === null || field.values === undefined ? [] : field.values;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            } else if (field.type === 'image') {
                // image：没有上传则传 0
                const value = field.values?.id ? field.values.id : 0;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            } else if (field.type === 'radio') {
                // radio：没有选择且不是必填只传id不传value
                if ((field.values === null || field.values === undefined) && !field.isRequired) {
                    signUpInfo.push({
                        id: field.id
                    });
                } else {
                    const value = field.values === null || field.values === undefined ? '' : field.values;
                    signUpInfo.push({
                        id: field.id,
                        value: value
                    });
                }
            } else {
                // text 等其他类型：没有填写则传空字符串
                const value = field.values === null || field.values === undefined ? '' : field.values;
                signUpInfo.push({
                    id: field.id,
                    value: value
                });
            }
        });

        let params = {
            formId: threadData?.form?.id,
            signUpInfo: signUpInfo,
            time: formCreateAt
        };

        thread.createFormSubmit(params).then((res: any) => {
            if (res?.code === 0 || res?.Code === 0) {
                Toast.success({ content: '提交成功' });
                // 提交成功后，保存数据状态，以便不刷新页面重新点击已填写时能显示内容
                this.setState({
                    popupStatus: false,
                    auditStatus: true,  // 设置为只读模式
                    formSubmittedData: formInfo  // 保存已提交的表单数据
                });
            } else {
                Toast.info({ content: res?.msg || res?.Message || '提交失败' });
            }
        });
    }

    // 确定举报
    reportConfirm = () => {
        let { threadId } = this.props;
        let { reportReason, reportType, selectedCommentId } = this.state;
        if (reportReason == '') {
            Toast.info('请选择举报理由');
            return false;
        }
        const { thread } = this.props;
        if (thread) {
            let params: any = {
                id: reportType == 1 ? threadId : selectedCommentId,
                type: reportType, // 0 个人主页 1 主题 2 评论/回复 3 问题反馈 4 活动 5 私信
                reason: reportReason
            }
            thread.createReports(params).then(res => {
                this.setState({
                    reportPopupStatus: false,   // 举报弹框
                    menuDropStatus: false,  // 举报下拉框收起
                }, () => {
                    Toast.info('举报成功');
                })

            })
        }
    }

    // 处理投票
    handleVoteClick = (option) => {
        console.log('选项:', { option });

        // 调用父组件传递的函数
        const { createActivityVote } = this.props;
        if (createActivityVote) {
            createActivityVote(option);
        }
    }

    // 处理删除评论
    handleDeleteComment = async () => {
        const { selectedCommentId } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'delete', 'comment');
            Toast.success({ content: '删除成功' });
            this.closeDeletePopup();
        } catch (error) {
            Toast.error({ content: '删除失败' });
        }
    }

    // 处理沉贴评论
    handleSinkComment = async () => {
        const { selectedCommentId, selectedCommentIsSink } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sink', 'comment', selectedCommentIsSink);
            Toast.success({ content: selectedCommentIsSink ? '取消沉贴成功' : '沉贴成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSink ? '取消沉贴失败' : '沉贴失败' });
        }
    }

    // 处理置顶评论
    handleStickyComment = async () => {
        const { selectedCommentId, selectedCommentIsSticky } = this.state;
        if (!selectedCommentId) return;

        try {
            await this.props.postsUpdate?.(selectedCommentId, 'sticky', 'comment', selectedCommentIsSticky);
            Toast.success({ content: selectedCommentIsSticky ? '取消置顶成功' : '置顶成功' });
            this.closeMenuDropStatus();
        } catch (error) {
            Toast.error({ content: selectedCommentIsSticky ? '取消置顶失败' : '置顶失败' });
        }
    }

    // 更新列表数据（已移至父组件 postsUpdate 方法中处理，此方法已废弃）
    updatePostList = (itemId: any, action: 'delete' | 'sink' | 'sticky') => {
        // MobX 数据更新现在在父组件 postsUpdate 中处理
    }

    // 关闭菜单下拉框
    closeMenuDropStatus = () => {
        this.setState({
            menuDropStatus: false,
            selectedCommentId: ''
        });
    }

    // 关闭删除弹框
    closeDeletePopup = () => {
        this.setState({
            deletePopupStatus: false,
            selectedCommentId: ''
        });
    }

    // 点击 @mention 跳转用户页
    handleMentionClick = (userId?: string) => {
        if (!userId) return;
        const { history } = this.props as any;
        if (history?.push) {
            history.push(`/user/${userId}`);
        }
    }

    replaceEmojiInContent = (content?: string) => {
        return replaceEmojiCodes(content || '', this.props.site?.emojiList || []);
    };

    handleThreadConversion = async (payload: ThreadConversionPayload) => {
        const { thread, threadId, user } = this.props;
        if (!getThreadConversionAccess(thread?.threadData, user?.userInfo).canConvert
            || String(payload.threadId) !== String(threadId)
            || payload.sourceType !== Number(thread?.threadData?.type)) {
            Toast.info({ content: '当前帖子不可转换，请刷新后重试' });
            throw new Error('当前帖子不可转换');
        }
        const blockedReason = getThreadConversionBlockedReason(thread?.threadData);
        if (blockedReason) {
            Toast.info({ content: blockedReason });
            throw new Error(blockedReason);
        }
        const result = await moveThread(threadId, getThreadConversionParams(payload));
        if (result?.code !== 0) {
            const message = result?.msg || '帖子转换未完成，请稍后重试';
            if (result?.errorType !== 'network') Toast.info({ content: message });
            throw new Error(message);
        }
    };

    // 当前帖子用户信息
    threadUserInfo = () => {
        const { thread, user, threadId, createFollowUser, followDelete } = this.props;
        let { menuDropStatus } = this.state;
        const threadData: any = thread?.threadData;
        const isSelf = (user as any)?.code && (user as any)?.code === threadData?.user?.code;
        return (
            <div className={styles.userInfoBox}>
                {/* 帖子作者、管理 */}
                <Avatar
                    avatarUrl={threadData?.user?.avatar}
                    userCode={threadData?.user?.code}
                    titleMark={threadData?.user?.titleMark}
                    level={threadData?.user?.level}
                    size={60}
                    officialSize={24}
                    levelBadgeWidth={30}
                    levelBadgeHeight={20}
                ></Avatar>
                <div className={styles.infoBox}>
                    <div className={styles.infoDetail}>
                        <div className={styles.userNameBox}>
                            <div className={styles.userName} style={{ maxWidth: threadData?.user?.titleName ? px2rem(200) : '' }}>{threadData?.user?.nickname}</div>
                            {
                                threadData?.user?.titleName && <div className={styles.userTitle}>{threadData?.user?.titleName}</div>
                            }

                        </div>
                        <div className={styles.userModel}>{threadData?.source}</div>
                    </div>
                    {/* 作者自己不展示关注按钮 */}
                    {!isSelf && <>
                        {!threadData?.user?.isFollow && <div className={styles.followBtn} onClick={() => window.globalEnsureLogin(createFollowUser)}>关注</div>}
                        {threadData?.user?.isFollow && <div className={styles.followedBtn} onClick={() => window.globalEnsureLogin(followDelete)}>已关注</div>}
                    </>}
                    <div className={styles.menuBox}>
                        <img src={`${BASE_IMG_URL}/common/menu2.png`} alt='管理' className={styles.menuIcon} onClick={() => {
                            console.log('点击管理', menuDropStatus);
                            this.setState({
                                menuDropStatus: !menuDropStatus
                            })
                        }} />
                    </div>
                </div>
                {/* 帖子管理 */}
                {menuDropStatus &&
                    <ManagePermissions
                        id={threadId}
                        threadData={threadData}
                        isSelf={isSelf}
                        isApproved={threadData?.isApproved}
                        canEdit={threadData?.permissions?.canEdit}
                        canEssence={threadData?.permissions?.canEssence}
                        canDelete={threadData?.permissions?.canDelete && !threadData?.deletedAt}
                        canStick={threadData?.permissions?.canSticky}
                        canHidden={threadData?.permissions?.canHide}
                        canDisplay={threadData?.permissions?.canDisplay}
                        canSink={threadData?.permissions?.canSink}
                        canRecommend={threadData?.permissions?.canRecommend}
                        canConvert={getThreadConversionAccess(threadData, user?.userInfo).canConvert}
                        handleConvert={this.handleThreadConversion}
                        isProhibited={threadData?.isProhibited}
                        isHidden={threadData?.isHidden}
                        isDisplay={threadData?.isDisplay}
                        isEssence={threadData?.isEssence}
                        isSticky={threadData?.isSticky}
                        stickyType={threadData?.stickyType}
                        stickyAt={threadData?.stickyExpiredAt && dayjs(threadData.stickyExpiredAt).isValid() ? threadData.stickyExpiredAt : undefined}
                        isSink={threadData?.isSink}
                        isRecommend={threadData?.isRecommend}
                        type={1}
                        handleSetState={(data, rep) => this.setState({ ...data })}
                        handleDisplay={() => console.log('显示')}
                        handleHidden={() => console.log('隐藏')}
                        handelManageClose={() => {
                            this.setState({
                                menuDropStatus: !menuDropStatus
                            })
                        }}
                        className="custom-class"
                    />
                }
            </div>
        )
    }

    // 帖子标签
    tagRender = (info) => {
        const tags: any = [];

        // 第一优先级标签, 规则 最多显示2个标签，第一个标签优先级：爆>热>顶>精>无；
        if (info?.isBoom) {
            tags.push({ img: `${BASE_IMG_URL}/common/fire.png`, alt: '爆款' });
        } else if (info?.isHot) {
            tags.push({ img: `${BASE_IMG_URL}/common/hot.png`, alt: '热门' });
        } else if (info?.isSticky != 0 || info?.showIndex === true) {
            tags.push({ img: `${BASE_IMG_URL}/common/stick.png`, alt: '置顶' });
        } else if (info?.isEssence) {
            tags.push({ img: `${BASE_IMG_URL}/common/essence.png`, alt: '精华' });
        } else if (info.isRecommend) {
            tags.push({ img: `${BASE_IMG_URL}/common/recommend.png`, alt: '推荐' });
        }

        // 赏标签（如果有）第二个标签优先级：赏>无
        if (info?.isReward) {
            tags.push({ img: `${BASE_IMG_URL}/common/reward.png`, alt: '有赏' });
        }

        if (tags.length === 0) {
            return null;
        }

        return (
            <>
                {tags.map((tag, index) => (
                    <img
                        key={index}
                        src={tag.img}
                        alt={tag.alt}
                        className={styles.postTag}
                        title={tag.alt}
                    />
                ))}
            </>
        );
    };

    // 过滤a标签白名单
    filterWhitelist = (content: string) => {
        const { whiteHttpList } = this.state || {}
        return cleanHttpLinks(content, whiteHttpList);
    };

    // 获取替换后的内容（用于图文帖）
    getReplacedContent = (content: string) => {
        const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';   // 是否是生产环境
        // 替换 vivoclub 协议链接为 HTTPS 链接
        // return content.replace(
        //     /https?:\/\/?vivoclub:\/\/com\.vivo\.club[^"']*/g,
        //     isProdEnv ? 'https://club.vivo.com.cn/downloadAppEnter' : 'https://club-test.vivo.com.cn/downloadAppEnter'
        // );
        return content.replace(
            /(?:https?:\/\/)?vivoclub:\/\/com\.vivo\.club[^"'<>()\s]*/g,
            isProdEnv ? 'https://club.vivo.com.cn/downloadAppEnter' : 'https://club.vivo.com.cn/downloadAppEnter'
        );
    };

    // 创建包含标签的内容
    createContentWithTags = () => {
        const { thread } = this.props;
        const threadData: any = thread?.threadData;
        const type = thread?.threadData?.type;
        if (!threadData?.content) return '';

        const tagsHtml = this.tagRender(threadData);

        const tagsString = tagsHtml ? `
            <span style="
                display: inline-block;
                vertical-align: top;
                margin-right: 6px;
                line-height: 1.5;
                white-space: nowrap;
            ">
                ${tagsHtml.props.children.map((child: any, index: number) =>
            `<img 
                        key="${index}"
                        src="${child.props.src}" 
                        alt="${child.props.alt}" 
                        class="${child.props.className}" 
                        title="${child.props.title}"
                        style="display: inline-block; vertical-align: middle; margin-right: 2px;"
                    />`
        ).join('')}
            </span>
        ` : '';

        let content;
        if ([1, 3].includes(Number(type))) {
            // 处理换行符：将 \n 替换为 <br>
            const processedContent = threadData.content
                .replace(/\r\n/g, '<br>')  // Windows 换行
                .replace(/\n/g, '<br>');   // Unix/Linux 换行

            content = `
                <div style="
                    line-height: 1.5;
                    word-break: break-word;
                ">
                    ${tagsString}
                    <span style="display: inline;">
                        ${processedContent}
                    </span>
                </div>
            `;
        } else if (type == 2) {
            // 反馈帖：拼接状态标签到内容前面
            const solveState = threadData?.feedback?.solveState;
            const statusMap: Record<string, { text: string; cls: string }> = {
                '0': { text: '未解决', cls: `${styles.feedbackStatus} ${styles.feedbackStatus0}` },
                '1': { text: '待处理', cls: `${styles.feedbackStatus} ${styles.feedbackStatus1}` },
                '2': { text: '已回复', cls: `${styles.feedbackStatus} ${styles.feedbackStatus2}` },
                '3': { text: '已解决', cls: `${styles.feedbackStatus} ${styles.feedbackStatus3}` },
            };
            const statusInfo = statusMap[String(solveState)];
            let processedContent = threadData.content
                .replace(/\r\n/g, '<br>')
                .replace(/\n/g, '<br>');
            if (statusInfo) {
                processedContent = `<span class="${statusInfo.cls}">${statusInfo.text}</span>${processedContent}`;
            }
            content = processedContent;
        } else {
            // 非微帖：同样处理换行符
            // const processedContent = threadData.content
            //     .replace(/\r\n/g, '<br>')
            //     .replace(/\n/g, '<br>');
            // content = tagsString + threadData.content;
            const processedContent = threadData.content
                .replace(/\r\n/g, '<br>')  // Windows 换行
                .replace(/\n/g, '<br>');   // Unix/Linux 换行

            content = `
                <div style="
                    line-height: 1.5;
                    word-break: break-word;
                ">
                    <span style="display: inline;">
                        ${processedContent}
                    </span>
                </div>
            `;
        }

        content = this.filterWhitelist(content);
        content = this.getReplacedContent(content);
        return content;
    };

    // 轮播图change事件
    handleSlideChange = (swiper: any) => {
        this.setState({
            swiperActiveIndex: swiper.activeIndex
        })

    };



    render() {
        const { thread, user, isVivoBrowserStatus, sendConfirmPopupStatus, sendConfirmClick, handleState, serviceStatus, satisfactionLevel, currentSatisfactionIndex, judgeTextValue } = this.props;
        let { rewardPopupStatus, rewardCheckValue, reportPopupStatus, reportReasonList, scrollY, formFixedIsShow, formFixedIsShowClose, menuDropStatus, swiperActiveIndex, deletePopupStatus } = this.state;
        if (!thread) { return <div>加载中...</div> }
        const threadData: any = thread.threadData;
        const isProtected = isContentProtectionEnabled(threadData?.allowDownload);
        const showProtectedToast = () => Toast.info({ content: '作者设置不支持下载图片' });
        const protectedMediaHandlers = isProtected
            ? {
                ...getProtectedEventHandlers(true),
                onContextMenu: (e: React.MouseEvent) => { e.preventDefault(); showProtectedToast(); },
            }
            : {};
        const pageProtectionProps = isProtected
            ? {
                ...protectedMediaHandlers,
                style: protectedMediaStyle,
            }
            : {};
        // const voteData = {
        //     question: "用vivo X300手机直播音乐节时，开启哪个设置能2.85%?",
        //     options: [
        //         { id: 'A', label: 'A', value: '关闭5G', votes: 125, percentage: 25 },
        //         { id: 'B', label: 'B', value: '调低屏幕亮度', votes: 375, percentage: 75 },
        //         { id: 'C', label: 'C', value: '禁用AI美化', votes: 0, percentage: 0 },
        //         { id: 'D', label: 'D', value: '省电模式', votes: 0, percentage: 0 }
        //     ],
        //     mode: 'single' as const,
        //     onSubmit: this.handleVoteSubmit,
        //     onVoteChange: this.handleVoteChange,
        //     hasVoted: false, // 初始状态
        //     totalVotes: 500,
        //     endAt: '2025-12-2 16:23:00',
        // };
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
                if (domNode.name === 'img') {
                    // return (
                    // <img
                    //     {...domNode.attribs}
                    //     loading="lazy"
                    //     onError={(e) => {
                    //     e.currentTarget.style.display = 'none';
                    //     }}
                    // />
                    // );
                }
                if (domNode.name === 'span' && domNode.attribs?.class?.includes('member') && domNode.attribs['data-code']) {
                    const userId = domNode.attribs['data-code'];
                    const styleAttr = domNode.attribs.style || '';
                    const firstChild = domNode.children?.[0];
                    const childStyleAttr = firstChild?.attribs?.style || '';
                    const colorSource = childStyleAttr || styleAttr;
                    const colorMatch = colorSource.match(/color\s*:\s*([^;]+)/i);
                    const mentionText = (domNode.children || []).map((child: any) => child?.data || child?.children?.[0]?.data || '').join('').trim() || domNode.children?.[0]?.children?.[0]?.data || '';

                    // 判断是否是当前用户
                    const isCurrentUser = userId === user.userInfo?.code;

                    const style: React.CSSProperties = {
                        cursor: 'pointer',
                        ...(colorMatch ? { color: colorMatch[1].trim() } : {}),
                        // 如果是当前用户，覆盖背景色和字体颜色
                        ...(isCurrentUser ? {
                            backgroundColor: '#002A8D',
                            borderRadius: '30px',
                            color: 'white',
                        } : {})
                    };
                    return (
                        <span
                            className={domNode.attribs.class}
                            style={style}
                            onClick={() => this.handleMentionClick(userId)}
                        >
                            {mentionText}
                        </span>
                    );
                }
            },
            ...options
        };
        // 创建包含标签的内容
        const contentWithTags = this.createContentWithTags();
        const isSelf = (user?.userInfo as any)?.code && (user?.userInfo as any)?.code === threadData?.user?.code;
        const lottery:any = threadData?.lotteryActivities?.length > 0 ? threadData?.lotteryActivities?.[0] : {};
        return (
            <div className={styles.wrapper} {...pageProtectionProps}>
                {!threadData?.id ? <div className={styles.loadingBox}>
                    <img src={`${BASE_IMG_URL}/common/loading.png`} alt="" className={styles.loadingIcon}/>
                    <div className={styles.loadingText}>正在加载...</div>
                </div>: <>


                    {threadData?.isPrivate && <div className={classNames(styles.examine, styles.examineError)}>
                        <div className={styles.innerTip}>
                            <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                            <div className={styles.tipsText}>经系统判断该帖存在质量问题，仅自己可见</div>
                        </div>
                    </div>}

                    {threadData?.isApproved == 0 &&
                        <div className={styles.examine}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon5.png`} />
                                <span className={styles.tipsText}>帖子审核中</span>
                            </div>
                        </div>
                    }
                    {threadData?.isApproved == 2 &&
                        <div className={classNames(styles.examine, styles.examineError)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                                <span className={styles.tipsText} onClick={() => this.props.history && this.props.history.push('/selfDiscipline')} style={{ cursor: 'pointer' }}>审核不通过，vivo社区提醒您发帖请遵守社区公约</span>
                            </div>
                        </div>
                    }

                    {(threadData?.isHidden && threadData?.isApproved == 1) &&
                        <div className={classNames(styles.examine, styles.examineHidden)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/eyes.png`} />
                                <span className={styles.tipsText}>{isSelf ? '仅自己可见' : '仅作者可见'}</span>
                            </div>
                        </div>
                    }

                    {(!threadData?.isDisplay && threadData?.isApproved == 1 && user?.userInfo?.group?.isAdmin) &&
                        <div className={classNames(styles.examine, styles.examineHidden)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/eyes.png`} />
                                <span className={styles.tipsText}>已屏蔽</span>
                            </div>
                        </div>
                    }

                    {(threadData?.isSink && threadData?.isApproved == 1 && user?.userInfo?.group?.isAdmin) &&
                        <div className={classNames(styles.examine, styles.examineHidden)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/thread_sink.png`} />
                                <span className={styles.tipsText}>已沉帖</span>
                            </div>
                        </div>
                    }
                    {threadData?.deletedAt &&
                        <div className={classNames(styles.examine, styles.examineError)}>
                            <div className={styles.innerTip}>
                                <img className={styles.tipsIcon} src={`${BASE_IMG_URL}/common/icon6.png`} />
                                <span className={styles.tipsText} onClick={() => this.props.history && this.props.history.push('/selfDiscipline')} style={{ cursor: 'pointer' }}>帖子已删除</span>
                            </div>
                        </div>
                    }

                    {/* 定时发布标识 */}
                    {threadData?.fixedAt && (
                        <div className={styles.fixedAtBox}>
                            <img
                                src={setPostImage.fixedAtIcon}
                                alt="定时发布"
                                className={styles.fixedAtIcon}
                            />
                            <span className={styles.fixedAtLabel}>定时发布：</span>
                            <span className={styles.fixedAtTime}>
                                {(() => {
                                    const date = new Date(threadData.fixedAt);
                                    const year = date.getFullYear();
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const hour = String(date.getHours()).padStart(2, '0');
                                    const minute = String(date.getMinutes()).padStart(2, '0');
                                    return (
                                        <>
                                            <span className={styles.fixedAtNum}>{year}</span> 年{' '}
                                            <span className={styles.fixedAtNum}>{month}</span> 月{' '}
                                            <span className={styles.fixedAtNum}>{day}</span> 日{' '}
                                            <span className={styles.fixedAtNum}>{hour}</span> 时{' '}
                                            <span className={styles.fixedAtNum}>{minute}</span> 分
                                        </>
                                    );
                                })()}
                            </span>
                        </div>
                    )}


                    {(threadData?.type == 0 && threadData?.title != '') && <div className={styles.titleBox}>
                        {this.tagRender(threadData)}
                        {threadData?.title}
                    </div>}
                    {/* 帖子作者 */}
                    {this.threadUserInfo()}
                    {(threadData?.images?.length > 0 && threadData?.type != 0) && <div className={styles.imagesListBox}>
                        <ThreadDetailImgList imageList={threadData?.images} isVivoBrowserStatus={isVivoBrowserStatus} allowDownload={threadData?.allowDownload}></ThreadDetailImgList>
                    </div>}


                    {/* 帖子内容 */}
                    <div className={styles.threadContentBox}>

                        {/* {ReactHtmlParser(threadData?.content?.text)} */}
                        <div className={classNames(styles.richeText, isProtected && styles.protectedRichText)}>
                            {Number(threadData?.type) === 2 ? <div className={styles.feedbackContent}>
                                {parse(this.replaceEmojiInContent(contentWithTags), parserOptions)}
                            </div> : parse(this.replaceEmojiInContent(contentWithTags || ''), parserOptions)}
                        </div>

                        {/* 问题反馈信息 */}
                        {threadData?.type == 2 && <div className={styles.feedbackDetailBox}>
                            <div className={styles.feedbackInfo}><span>问题类型：</span>{threadData?.feedback?.problem?.name}</div>
                            <div className={styles.feedbackInfo}><span>手机型号：</span>{getFeedbackProductName(threadData?.feedback?.product)}</div>
                            <div className={styles.feedbackInfo}><span>软件版本号：</span>{threadData?.feedback?.systemVersion}</div>
                            {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.imei &&  <div className={styles.feedbackInfo}><span>IMEI1号：</span>{threadData?.feedback?.imei}（仅官方可见）</div>}
                            {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.logCode && <div className={styles.feedbackInfo}><span>操作日志：</span>{threadData?.feedback?.logCode}（仅官方可见）</div>}
                            {(isSelf || user?.userInfo?.group?.isAdmin) && threadData?.feedback?.phone && <div className={styles.feedbackInfo}><span>联系电话：</span>{threadData?.feedback?.phone}（仅官方可见）</div>}
                        </div>}

                        {threadData?.video && <div className={styles.videoBox}>
                            <video
                                src={threadData.video?.url}
                                width="640"
                                height="360"
                                controls
                                poster={threadData.video?.videoCoverUrl}
                                preload="metadata"
                                playsInline
                                webkit-playsinline=""
                                x5-playsinline=""
                                x5-video-player-type="inline"
                                x5-video-player-fullscreen="false"
                                t7-video-player-type="inline"
                                style={isProtected ? protectedMediaStyle : undefined}
                                {...protectedMediaHandlers}
                            >
                                您的浏览器不支持 video 标签。
                            </video>
                        </div>}
                        {/* 投票 */}
                        <div className={styles.voteBox}>
                            <VoteList threadData={threadData} votesData={threadData?.votes} onSubmit={(option) => this.handleVoteClick(option)} hasVoted={threadData?.votes?.[0]?.isVoted} />
                        </div>
                        {/* 帖子合集 */}
                        {threadData?.collection?.length > 0 && <div className={styles.collectionList}>
                            {threadData?.collection?.map((item: any, idx: number) => (
                                <div key={item?.id ?? `collection-${idx}`} className={styles.collectionItem}>
                                    {item.coverUrl != '' && <img src={item.coverUrl} alt="" className={styles.collectionCover} onClick={() => this.handleThreadClick(item)} />}
                                    <div className={styles.collectionDetail}>
                                        <div className={styles.collectionTitle} onClick={() => this.handleThreadClick(item)}>{item.title || item.summary}</div>
                                        <div className={styles.collectionInfo}>
                                            <div className={styles.collectionUserBox}>
                                                <Avatar avatarUrl={item.avatar} officialSize={16} titleMark={item?.titleMark} size={32}></Avatar>
                                                <div className={styles.name}>{item.user?.nickname}</div>
                                            </div>
                                            <div className={styles.infoOperaBox}>
                                                <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                                    <img src={`${BASE_IMG_URL}/common/comment.png`} alt="" className={styles.icon} />
                                                    <div className={styles.count}>{item.postCount}</div>
                                                </div>
                                                <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                                    <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon} />
                                                    <div className={styles.count}>{item.likeCount}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                        {/* 表单入口 */}
                        {threadData?.hasForm && <div className={styles.formEntryBox} onClick={() => {
                            if (!this.props.user?.userInfo?.id) {
                                const { user } = this.props as any;
                                if (user && typeof user.checkLogin === 'function') {
                                    const isLogin = user.checkLogin();
                                    if (!isLogin) {
                                        console.log('[SetPost] User not logged in, aborting init (checkLogin handled redirect)');
                                        return;
                                    }
                                }
                                Toast.info({ content: '请先登录!' });
                                return;
                            }

                            // 规则1：未开始 - 不支持打开，提示"活动未开始"
                            if (this.state.formStatus === 'notStarted') {
                                Toast.info({ content: '活动未开始' });
                                return;
                            }

                            // 规则3：未填写且已结束 - 不支持打开，提示"活动已结束"
                            if (this.state.formStatus === 'ended' && !threadData?.form?.isSubmitted) {
                                Toast.info({ content: '活动已结束' });
                                return;
                            }

                            // 规则2：已填写 - 支持打开查看，进行中可编辑，已结束只读
                            // 当form.isSubmitted=true时，传入isReadOnly标识。只读模式由onGetFormInfoList内部根据是否有数据判断
                            const isReadOnly = threadData?.form?.isSubmitted && this.state.formStatus === 'ended';

                            this.onGetFormInfoList(isReadOnly);
                            this.setState({ popupStatus: true });
                        }}>
                            <div className={styles.formIcon}></div>
                            <div className={styles.formEntryContent}>
                                <div className={styles.formEntryTitle}>{threadData?.form?.name || '填写信息'}</div>
                                <div className={styles.formEntryInfoRow}>
                                    {(threadData?.form?.userCount || 0) > 0 && <div className={styles.formEntryNum}>已有<span>{threadData?.form?.userCount}</span>人参与</div>}
                                    {this.state.formStatus === 'ongoing' && (
                                        <div className={styles.formCountdown}>
                                            距结束：
                                            {(this.state.formCountdown as any)?.isEnded ? (
                                                <span>{(this.state.formCountdown as any).text}</span>
                                            ) : (
                                                <>
                                                    {(this.state.formCountdown as any)?.days && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).days}</span><span>天</span></>}
                                                    {(this.state.formCountdown as any)?.hours !== undefined && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).hours}</span><span>时</span></>}
                                                    {(this.state.formCountdown as any)?.minutes !== undefined && <><span className={styles.countdownNumber}>{(this.state.formCountdown as any).minutes}</span><span>分</span></>}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className={styles.formBtnWrap}>
                                    {this.state.formStatus === 'notStarted' && <span className={styles.startBtn}>未开始</span>}
                                    {this.state.formStatus === 'ongoing' && <span className={styles.filledBtn}>{threadData?.form?.isSubmitted ? '已填写' : '点击填写'}</span>}
                                    {this.state.formStatus === 'ended' && <span className={styles.endedBtn}>已结束</span>}
                                </div>
                            </div>
                        </div>}

                        {(formFixedIsShow && !formFixedIsShowClose && this.state.formStatus === 'ongoing') && <div className={styles.formFixedEnterBox}>
                            <img src={`${BASE_IMG_URL}/common/close3.png`} alt="" className={styles.close} onClick={() => { this.setState({
                                formFixedIsShow: false,
                                formFixedIsShowClose: true
                            }) }}/>
                            <div className={styles.formFixedTitle}>报名表单</div>
                            <div className={styles.formFixedBtnWrap}  onClick={() => {
                            if (!this.props.user?.userInfo?.id) {
                                const { user } = this.props as any;
                                if (user && typeof user.checkLogin === 'function') {
                                    const isLogin = user.checkLogin();
                                    if (!isLogin) {
                                        // console.log('[SetPost] User not logged in, aborting init (checkLogin handled redirect)');
                                        return;
                                    }
                                }
                                Toast.info({ content: '请先登录!' });
                                return;
                            }

                            // 规则1：未开始 - 不支持打开，提示"活动未开始"
                            if (this.state.formStatus === 'notStarted') {
                                Toast.info({ content: '活动未开始' });
                                return;
                            }

                            // 规则3：未填写且已结束 - 不支持打开，提示"活动已结束"
                            if (this.state.formStatus === 'ended' && !threadData?.form?.isSubmitted) {
                                Toast.info({ content: '活动已结束' });
                                return;
                            }

                            // 规则2：已填写 - 支持打开查看，进行中可编辑，已结束只读
                            // 当form.isSubmitted=true时，传入isReadOnly标识。只读模式由onGetFormInfoList内部根据是否有数据判断
                            const isReadOnly = threadData?.form?.isSubmitted && this.state.formStatus === 'ended';

                            this.onGetFormInfoList(isReadOnly);
                            this.setState({ popupStatus: true });
                        }}>
                                {/* {this.state.formStatus === 'notStarted' && <span className={styles.startBtn}>未开始</span>} */}
                                {this.state.formStatus === 'ongoing' && <span className={styles.filledBtn}>{threadData?.form?.isSubmitted ? '已填写' : '点击填写'}</span>}
                                {/* {this.state.formStatus === 'ended' && <span className={styles.endedBtn}>已结束</span>} */}
                            </div>
                        </div>}

                        {/* 抽奖入口 */}
                        {lottery && lottery?.length !== 0 && JSON.stringify(lottery) !== '{}' &&
                            <div id="lotteryEnter" className={lottery?.type == 2 ? styles.entryLottery : styles.entryAuto} onClick={() => {
                                this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                            }}>
                                <div className={styles.lotteryIconBox}>
                                    <div className={styles.lotteryTip}><img src={`${BASE_IMG_URL}/lottery/icon9.png`} className={styles.icon}/>抽奖</div>
                                    <img src={lottery?.coverUrl} className={styles.lotteryIcon}/>
                                </div>

                                <div className={styles.lotteryInfo}>
                                    <div className={styles.lotteryName}>{lottery?.name}</div>
                                    {(lottery?.status == 0 || lottery?.status == 1) && <div className={styles.lotteryTime}>{lottery?.status == 0 ? '距开始：' :'距结束：'}<CountDown number={lottery?.status == 0 ? new Date(lottery.startAt).getTime() : new Date(lottery.endAt).getTime()} endText='&nbsp;' itemStylesData={{background: 'transparent',color: lottery.foregroundColor,padding: '0', height: px2rem(32), lineHeight: px2rem(32)}} boxStylesData={{justifyContent:'center', color:'#939598'}}/></div>}
                                    {lottery?.status == 3 && <div className={styles.lotteryUserNum}>已有<span>{lottery?.lotteryUsers}</span>人参与</div>}

                                    {/* 抽奖按钮 */}
                                    {lottery?.status == 0 &&
                                        <div className={classNames(styles.lotteryBtn,styles.lotteryBtn1)}>
                                            即将开始
                                        </div>
                                    }
                                    {lottery?.status == 1 &&
                                        <div className={classNames(styles.lotteryBtn,styles.lotteryBtn2)}>
                                            去抽奖
                                        </div>
                                    }
                                    {lottery?.status == 3 &&
                                    <div className={classNames(styles.lotteryBtn,styles.lotteryBtn3)}>
                                        已结束
                                    </div>
                                    }
                                </div>
                            </div>
                        }
                        {/* 抽奖悬浮入口 */}
                        {lottery && lottery?.length !== 0 && JSON.stringify(lottery) !== '{}' && this.state.showLotteryFixedEnter && this.state.hideLotteryFixedEnter && <>
                            <div className={classNames(styles.lotteryFixedEnter, lottery?.status == 3 ? styles.lotteryOverEnter : '')}>
                                <img src={`${BASE_IMG_URL}/lottery/close1.png`} className={styles.close} onClick={() => this.setState({ hideLotteryFixedEnter: false })} />
                                <div className={styles.lotteryIconBox} onClick={() => {
                                    this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                                }}>
                                    <div className={styles.lotteryTip}><img src={`${BASE_IMG_URL}/lottery/icon9.png`} className={styles.icon}/>抽奖</div>
                                    <img src={lottery?.coverUrl} className={styles.lotteryIcon}/>
                                </div>
                                {/* 抽奖按钮 */}
                                {lottery?.status == 0 &&
                                    <div className={classNames(styles.lotteryBtn)} onClick={() => {
                                        this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                                    }}>
                                                即将开始
                                    </div>
                                }
                                {lottery?.status == 1 &&
                                    <div className={classNames(styles.lotteryBtn)} onClick={() => {
                                        this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                                    }}>
                                        去抽奖
                                    </div>
                                }
                                {lottery?.status == 3 &&
                                <div className={classNames(styles.lotteryBtn)} onClick={() => {
                                    this.props.history && this.props.history.push(`/lottery/${lottery?.code}`);
                                }}>
                                    已结束
                                </div>
                                }
                            </div>
                        </>}


                        <div className={styles.topicList}>
                            {threadData?.topics?.map((topic: any, idx: number) => (
                                <span key={topic?.id ?? `topic-${idx}`} className={styles.topicName} onClick={() => {
                                    this.props.history && this.props.history.push(`/topicDetail/${topic.id}`);
                                }}>{topic.name}</span>
                            ))}
                        </div>
                        <div className={styles.threadBottomInfoBox}>
                            <div className={styles.threadBottomInfoLeft}>
                                {/* {threadData?.isAigc && (
                                    <div className={styles.aiTagBox}>
                                        <img
                                            src={setPostImage.aiIcon}
                                            alt="AI生成"
                                            className={styles.aiIcon}
                                        />
                                        <span className={styles.aiText}>作者声明：内容含AI生成元素</span>
                                    </div>
                                )} */}
                                {/* AI声明 */}
                                {threadData?.aigcStatus != 0 && (
                                    <div className={styles.aiTagBox}>
                                        <img
                                            src={setPostImage.aiIcon}
                                            alt="AI生成"
                                            className={styles.aiIcon}
                                        />
                                        {threadData?.aigcStatus == 2 && <span className={styles.aiText}>{threadData?.isAigc ? '作者声明：内容含AI生成元素' : '内容可能含AI生成元素'}</span>}
                                        {threadData?.aigcStatus == 1 && <span className={styles.aiText}>内容含AI生成元素</span>}
                                        {threadData?.aigcStatus == 3 && <span className={styles.aiText}>内容含疑似AI生成元素</span>}
                                    </div>
                                )}
                                <div className={styles.threadBottomInfo}>
                                    <div className={styles.postTime}>{formatTime(threadData?.createdAt)}</div>
                                    {threadData?.source && <div className={styles.postArea}>{threadData?.source}</div>}
                                    {threadData?.ipRegion && <div className={styles.postArea}>{threadData?.ipRegion}</div>}
                                </div>
                                {!isSelf && threadData?.type == 2 && <div className={classNames(styles.feedbackSame, threadData?.feedback?.isSame ? styles.feedbackSameGray : '')} onClick={() => window.globalEnsureLogin(() => this.props.submitFeedbackSame?.())}>{!threadData?.feedback?.isSame ? '我也遇到了相同问题' : '反馈成功'}</div>}
                            </div>
                            {(isSelf || user?.userInfo?.group?.isAdmin) && <div className={styles.viewCount}>{formatNumberToWan(threadData?.viewCount)}</div>}
                        </div>

                        <div className={styles.rewardBtn} onClick={() => window.globalEnsureLogin(() => this.openRewardPopup())}>
                            <img src={`${BASE_IMG_URL}/common/icon14.png`} alt="" className={styles.rewardIcon} />
                            <span className={styles.rewardText}>打赏</span>
                        </div>
                        {(threadData?.lastRewardedUsers && threadData?.lastRewardedUsers.length > 0) && <div className={styles.rewardUserList}>
                            <AvatarList userList={threadData?.lastRewardedUsers} size={36}></AvatarList>
                            <div className={styles.text}>{threadData?.rewardedCount}人已打赏</div>
                        </div>}

                        {/* 打赏弹框 */}
                        <CommonPopup
                            visible={rewardPopupStatus}
                            title='支持作者继续创作'
                            onCancelChange={() => this.closePopup()}
                            onConfirmButtonChange={() => this.rewardConfirm()}
                        >
                            {/* children 插槽内容 */}
                            <div className={classNames(styles.rewardListBox, threadData?.rewardScoreList?.length == 2 ? styles.rewardFewListBox : '')}>
                                {threadData?.rewardScoreList?.map((item, index) => (
                                    <div key={`reward-${item ?? index}`} className={classNames(styles.rewardItem, rewardCheckValue === item ? styles.rewardItemActive : '')} onClick={() => {
                                        this.setState({
                                            rewardCheckValue: item
                                        })
                                    }}>
                                        {rewardCheckValue === item && <img src={`${BASE_IMG_URL}/common/icon12.png`} alt="" className={styles.icon} />}
                                        {rewardCheckValue !== item && <img src={`${BASE_IMG_URL}/common/icon12.png`} alt="" className={styles.icon} />}
                                        <div className={styles.text}>{item} V币</div>
                                    </div>
                                ))}
                            </div>

                        </CommonPopup>
                        {/* 举报弹框 */}
                        <CommonPopup
                            visible={reportPopupStatus}
                            title="举报"
                            onCancelChange={() => this.closePopup()}
                            onConfirmButtonChange={() => this.reportConfirm()}
                        >
                            {/* children 插槽内容 */}
                            <div className={styles.reportPopupSlotBox}>
                                <div className={styles.reportText}>
                                    <span className={styles.must}>*</span>举报理由
                                    <span>请选择举报理由</span>
                                </div>
                                <div className={styles.reportReasonListBox}>
                                    <Radio.Group
                                        name="radiogroup"
                                        defaultValue={1}
                                        onChange={(e) => {
                                            this.setState({
                                                reportReason: e.target.value,
                                            });
                                        }}
                                        options={reportReasonList}
                                    />
                                </div>
                                <div className={styles.reportText}>举报描述</div>
                                <TextArea rows={4} placeholder="请输入举报理由" maxLength={600} />
                            </div>
                        </CommonPopup>

                        {/* 表单弹窗 */}
                        {this.state.popupStatus && (
                            <div className={styles.formPopupWrapper}>
                                <div className={styles.formPopupBox}>
                                    {/* 顶部导航栏 */}
                                    <div className={styles.formHeader}>
                                        <div className={styles.formTitle}>{thread?.threadData?.form?.name || '填写信息'}</div>
                                        <div className={styles.formHeaderPlaceholder}></div>
                                    </div>

                                    {/* 表单内容区域 */}
                                    <div className={styles.formContent}>
                                        {this.state.formInfo?.map((field: any, index: number) => (
                                            <div key={`form-field-${index}`} className={styles.formFieldBox}>
                                                <div className={styles.formFieldLabel}>
                                                    {field.isRequired && <span className={styles.required}>*</span>}
                                                    {index + 1}.{field.name}
                                                    {field.type === 'checkbox' && <span className={styles.fieldType}>（多选）</span>}
                                                </div>

                                                {field.type === 'input' && (
                                                    <div className={styles.inputWrapper}>
                                                        <textarea
                                                            placeholder={field.placeholder || '请输入'}
                                                            value={field.values || ''}
                                                            onChange={(e) => !this.state.auditStatus && this.onWzNum(index, e.target.value)}
                                                            maxLength={500}
                                                            className={styles.formTextarea}
                                                            disabled={this.state.auditStatus}
                                                        />
                                                    </div>
                                                )}

                                                {field.type === 'checkbox' && (
                                                    <div className={styles.optionGroup}>
                                                        {field.list?.map((option: any, key: number) => {
                                                            // 支持两种状态格式：list中的checked属性或values数组中的索引
                                                            const isChecked = option.checked || (Array.isArray(field.values) && field.values.includes(String(key)));
                                                            return (
                                                                <div
                                                                    key={`checkbox-${index}-${key}`}
                                                                    className={classNames(
                                                                        styles.optionItem,
                                                                        isChecked ? styles.optionItemActive : ''
                                                                    )}
                                                                    onClick={() => !this.state.auditStatus && this.onCheckBox(index, key)}
                                                                >
                                                                    <span className={styles.optionLabel}>{option.label}</span>
                                                                    {isChecked && <img src={`${BASE_IMG_URL}/common/icon10.png`} alt="" className={styles.checkedIcon}/>}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}

                                                {field.type === 'radio' && (
                                                    <div className={styles.optionGroup}>
                                                        {field.options?.map((option: any, key: number) => (
                                                            <div
                                                                key={`radio-${index}-${key}`}
                                                                className={classNames(
                                                                    styles.optionItem,
                                                                    (field.values === key || field.values === String(key)) ? styles.optionItemActive : ''
                                                                )}
                                                                onClick={() => !this.state.auditStatus && this.onRadioChange(index, key)}
                                                            >
                                                                <span className={styles.optionLabel}>{option}</span>
                                                                {(field.values === key || field.values === String(key)) && <img src={`${BASE_IMG_URL}/common/icon10.png`} alt="" className={styles.checkedIcon}/>}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {field.type === 'image' && (
                                                    <div className={styles.uploadWrapper}>
                                                        {field.values ? (
                                                            <div className={styles.uploadedBox}>
                                                                <img src={typeof field.values === 'object' ? field.values.url : field.values} alt="已上传" className={styles.uploadedImage} />
                                                                {!this.state.auditStatus && <div className={styles.deleteBtn} onClick={() => {
                                                                    let { formInfo } = this.state;
                                                                    formInfo[index].values = null;
                                                                    this.setState({ formInfo }, () => this.onCheckedFormStatus());
                                                                }}>×</div>}
                                                            </div>
                                                        ) : (
                                                            !this.state.auditStatus && <div className={styles.uploadBox} onClick={() => this.handleImageUploadClick(index)}>
                                                                <div className={styles.uploadIcon}>+</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    {/* 底部固定区域：协议+按钮 */}
                                    <div className={styles.formBottom}>
                                        {/* 用户协议 - 只读模式下隐藏 */}
                                        {!this.state.auditStatus && <div className={styles.formConsent}>
                                            <div
                                                className={classNames(
                                                    styles.consentCheckbox,
                                                    this.state.consentStatus ? styles.checked : ''
                                                )}
                                                onClick={() => {
                                                    this.setState({ consentStatus: !this.state.consentStatus }, () => this.onCheckedFormStatus());
                                                }}
                                            ></div>
                                            <div className={styles.consentText}>
                                                我已阅读并接受 <span className={styles.link} onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.history && this.props.history.push(`/selfDiscipline`);
                                                }}>用户协议</span> 和 <span className={styles.link} onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.history && this.props.history.push(`/privacy`);
                                                }}>隐私政策</span>
                                            </div>
                                        </div>}

                                        {/* 底部提交按钮 */}
                                        <div className={styles.formFooter}>
                                            <button
                                                className={styles.cancelBtn}
                                                onClick={() => this.setState({ popupStatus: false })}
                                            >
                                                取消
                                            </button>
                                            {!this.state.auditStatus && <button
                                                className={classNames(
                                                    styles.submitBtn,
                                                    !this.state.submitStatus ? styles.submitBtnDisabled : ''
                                                )}
                                                disabled={!this.state.submitStatus}
                                                onClick={() => {
                                                    if (this.state.submitStatus) {
                                                        this.onSendServer(null);
                                                    }
                                                }}
                                            >
                                                提交
                                            </button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 表单提交确认弹窗 */}
                        <div className={styles.formSubmitConfirmWrapper}>
                            <CommonAlert
                                visible={this.state.formSubmitConfirmVisible}
                                title="提示"
                                text="提交后将无法修改，请确认是否提交？"
                                onCancelChange={() => this.setState({ formSubmitConfirmVisible: false })}
                                onConfirmButtonChange={() => this.confirmSubmitForm()}
                                cancelText="取消"
                                confirmText="确认提交"
                            />
                        </div>
                    </div>
                </>}
                <div className={styles.threadContentBox}>
                    <div className={styles.postListBox}>
                        <PostList
                            threadId={threadData?.id || this.props.threadId}
                            threadType={0}
                            handleSetState={(data, rep) => this.setState({ ...data }, () => {
                                console.log('handleSetState-data', data)
                            })}
                            onPostLike={(comment) => {
                                window.globalEnsureLogin(() => this.props.likeClick?.(comment, 'post'));
                            }}
                            onDeleteComment={async (itemId) => {
                                this.setState({ selectedCommentId: itemId });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'delete', 'comment');
                                    Toast.success({ content: '删除成功' });
                                } catch (error) {
                                    Toast.error({ content: '删除失败' });
                                }
                            }}
                            onSinkComment={async (itemId, currentIsSink) => {
                                this.setState({ selectedCommentId: itemId, selectedCommentIsSink: currentIsSink });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'sink', 'comment', currentIsSink);
                                    Toast.success({ content: currentIsSink ? '取消沉贴成功' : '沉贴成功' });
                                } catch (error) {
                                    Toast.error({ content: currentIsSink ? '取消沉贴失败' : '沉贴失败' });
                                }
                            }}
                            onStickyComment={async (itemId, currentIsSticky) => {
                                this.setState({ selectedCommentId: itemId, selectedCommentIsSticky: currentIsSticky });
                                try {
                                    await this.props.postsUpdate?.(itemId, 'sticky', 'comment', currentIsSticky);
                                    Toast.success({ content: currentIsSticky ? '取消置顶成功' : '置顶成功' });
                                } catch (error) {
                                    Toast.error({ content: currentIsSticky ? '取消置顶失败' : '置顶失败' });
                                }
                            }}
                        ></PostList>
                    </div>
                </div>
                {/* H5 底部悬浮操作栏 */}
                <div className={styles.bottomBarWrapper}>
                    {(threadData?.feedback?.isSendConfirm && isSelf && serviceStatus) && (
                        <div className={styles.serviceBox}>
                            <img
                                src={`${BASE_IMG_URL}/feedback/icon8.png`}
                                alt=""
                                className={styles.serviceIcon}
                                onClick={() => handleState?.({ sendConfirmPopupStatus: true })}
                            />
                            <img
                                src={`${BASE_IMG_URL}/common/close.png`}
                                alt=""
                                className={styles.serviceClose}
                                onClick={() => handleState?.({ serviceStatus: false })}
                            />
                        </div>
                    )}
                    <div className={styles.bottomBar}>
                        <div className={styles.shareInput} onClick={() => window.globalEnsureLogin(() => this.setState({ commentInputVisible: true }))}>
                            <span className={styles.sharePlaceholder}>分享脑洞</span>
                        </div>
                        <div className={styles.ops}>
                            <div className={styles.opItem} onClick={() => this.props.shareClick?.()}>
                                <img src={`${BASE_IMG_URL}/common/share3.png`} alt="" className={styles.opIcon} />
                                <div className={styles.opText}>{threadData?.shareCount || '转发'}</div>
                            </div>
                            <div className={styles.opItem} onClick={() => window.globalEnsureLogin(() => this.props.favoriteClick?.(threadData?.isFavorite))}>
                                <img src={threadData?.isFavorite ? `${BASE_IMG_URL}/common/favorited.png` : `${BASE_IMG_URL}/common/favorite2.png`} alt="" className={styles.opIcon} />
                                <div className={styles.opText}>{threadData?.favoriteCount || '收藏'}</div>
                            </div>
                            <div className={styles.opItem} onClick={() => window.globalEnsureLogin(() => this.setState({ commentInputVisible: true }))}>
                                <img src={`${BASE_IMG_URL}/common/comment2.png`} alt="" className={styles.opIcon} />
                                <div className={styles.opText}>{threadData?.postCount || '评论'}</div>
                            </div>
                            <div className={styles.opItem} onClick={() => window.globalEnsureLogin(() => this.props.likeClick?.(threadData, 'thread'))}>
                                <img src={threadData?.isLiked ? `${BASE_IMG_URL}/common/liked.png` : `${BASE_IMG_URL}/common/like2.png`} alt="" className={styles.opIcon} />
                                <div className={styles.opText}>{threadData?.likeCount || '点赞'}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 用户确认有无帮助弹框 */}
                <CommonPopupNew
                    visible={sendConfirmPopupStatus}
                    title="客服的反馈是否已解决你的问题?"
                    isShowConfirm={false}
                    isShowCancel={false}
                    >
                    {/* children 插槽内容 */}
                    <div className={styles.solveStatusBox}>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick(1)}>已解决</div>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick(2)}>未解决</div>
                        <div className={styles.solveCancle} onClick={() => handleState({ sendConfirmPopupStatus: false })}>取消</div>
                    </div>

                    {/* 反馈评价完整版 使用完整版时，要放开弹框组件的取消和确认按钮，并完善sendConfirmClick里的接口参数， 注意： 完整版的弹框要紧贴底部 */}
                    {/* <div className={styles.judgeTitle}>客服的反馈是否已解决你的问题：</div>
                    <div className={classNames(styles.solveStatusBox, styles.solveStatusBox2)}>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(1)}>已解决</div>
                        <div className={styles.solveStatus} onClick={() => sendConfirmClick?.(2)}>未解决</div>
                    </div>
                    <div className={styles.judgeTitle}>你对本次反馈服务的满意程度：</div>
                    <div className={styles.satisfactionLevelList}>
                        {satisfactionLevel.map((level, index) => (
                            <div className={classNames(styles.levelItem, currentSatisfactionIndex == index ? styles.levelItemActive : '')} onClick={() => {
                                handleState?.({ currentSatisfactionIndex: index })
                            }}>
                                <img src={currentSatisfactionIndex != index ? `${BASE_IMG_URL}${level.icon}.png` : `${BASE_IMG_URL}${level.icon}-active.png`} alt="表情" className={styles.icon}/>
                                <div className={styles.text}>{level.text}</div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.judgeTitle}>你对本次反馈服务的评价或建议：</div>
                    <textarea name="" id="" placeholder='如有请填写' className={styles.judgeTextarea}  value={judgeTextValue} onChange={(e) => {handleState?.({ judgeTextValue: e.target?.value })}}></textarea> */}

                </CommonPopupNew>

                {/* 评论输入框 */}
                {this.state.commentInputVisible && (
                    <CommentInput
                        type="post"
                        threadId={threadData?.id || this.props.threadId}
                        commentType={0}
                        onSubmit={async (data) => {
                            // 提交成功后关闭输入框并添加新评论到列表
                            this.setState({ commentInputVisible: false });

                            // 将新评论添加到列表顶部
                            if (data.newComment && thread) {
                                thread.prependPostToList?.(data.newComment);
                            }
                        }}
                        onCancel={() => this.setState({ commentInputVisible: false })}
                    />
                )}

            </div>
        )
    }
}

export default withRouter(ThreadDetailH5Page);
